import Button from 'components/Button';
import Typography from 'components/Typography';
import { FC } from 'react';
import styled from 'styled-components';
import { Color } from 'utils/getPalette';
import Modal, { ModalProps } from '.';

const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  margin-left: auto;
  margin-right: 0;
  margin-top: 2rem;
  flex-wrap: wrap-reverse;
  gap: 0.5rem;
`;

type Props = ModalProps & {
  color?: Color;
  title: string;
  cancel?: () => void;
  cancelText?: string;
  apply: () => void;
  applyText?: string;
  loading?: boolean;
};

const ActionModal: FC<Props> = ({
  children,
  open,
  close,
  color,
  title,
  cancel,
  cancelText,
  apply,
  applyText,
  loading,
}) => {
  return (
    <Modal open={open} close={close}>
      <div></div>
      <Typography variant="h2" color={color} style={{ marginBottom: '1rem' }}>
        {title}
      </Typography>
      {children}

      <ButtonsContainer>
        <Button variant="outlined" onClick={cancel || close}>
          {cancelText || 'Annuler'}
        </Button>
        <Button color={color} onClick={apply} loading={loading}>
          {applyText || 'Valider'}
        </Button>
      </ButtonsContainer>
    </Modal>
  );
};

export default ActionModal;
